import { createFileRoute } from '@tanstack/react-router';
import { eventCountQuery, eventsQuery } from '@/features/events/api';
import { EventsPage } from '@/features/events/pages/EventsPage';
import { eventsSearchSchema, tabWindow, toEventsQuery } from '@/features/events/search';
import { sourcesQuery } from '@/features/sources/api';
import { belgradeToday } from '@/lib/format/format';

export const Route = createFileRoute('/_authed/ops/events/')({
  staticData: { help: 'published-events' },
  validateSearch: eventsSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps }) => {
    const today = belgradeToday();
    void queryClient.prefetchQuery(eventsQuery(toEventsQuery(deps, today)));
    void queryClient.prefetchQuery(eventCountQuery(tabWindow('live', today)));
    void queryClient.prefetchQuery(eventCountQuery(tabWindow('past', today)));
    void queryClient.prefetchQuery(sourcesQuery());
  },
  component: EventsPage,
});
